'use client';

import { CMSLink } from '@/components/Link';
import { ChevronDown } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { clsx } from 'clsx';
import { Link } from '@/payload-types';
import { WithSublinks } from '@/types/WithSublinks';

interface IHeaderLinkItemProps {
  item: {
    id?: string | null;
    link: Link & WithSublinks;
  };
}

export default function MHeaderLinkItem(props: IHeaderLinkItemProps) {
  const { item } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);

  const [sublinkBlockHeight, setSublinkBlockHeight] = useState(0);
  const sublinkBlockRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const resizeHandler = () => {
      setSublinkBlockHeight(sublinkBlockRef.current?.scrollHeight || 0);
    };

    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    return () => window.removeEventListener('resize', resizeHandler);
  }, []);

  return (
    <li className="w-full">
      <div className="flex items-center justify-between">
        <CMSLink {...item.link} className="font-medium" />
        {Boolean(item.link.sublink?.length) && (
          <button
            className="flex flex-1 justify-end"
            onClick={toggleExpand}
            aria-label='Expand menu'
          >
            <ChevronDown
              height={16}
              className={clsx('transition-all duration-500', isExpanded && '-rotate-180')}
            />
          </button>
        )}
      </div>
      {Boolean(item.link.sublink?.length) && (
        <div
          className="overflow-hidden transition-all duration-500"
          ref={sublinkBlockRef}
          style={{ height: isExpanded ? sublinkBlockHeight : 0 }}
        >
          <ul className="p-3 mt-1 bg-white rounded-lg border border-neutral-200">
            {item.link.sublink?.map((sublink, index) => (
              <li key={`${item.id}_${index}`} >
                <CMSLink
                  {...sublink}

                  className="font-medium block py-1 w-full not-last-of-type:mb-2"
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </li>
  );
}
